import React from 'react';
import classNames from 'classnames';
import { LoadingIndicator } from 'Permafrost/index';
import { StyledLoadingAwareContainer, StyledStatusContainer } from './LoadingAwareContainer.styles';
/**
 * A functional container for content that is yet to load or will change; displays a loading indicator and announces
 * to Assistive Technology as needed.
 *
 * todo: this is an extremely simple version of this component; as I get more familiar with LoadingIndicator use cases, this will be refactored. - jm 9/1/2020
 */
export function LoadingAwareContainer(props) {
    const { children, className, isLoading, style } = props;
    return (React.createElement(StyledLoadingAwareContainer, { className: classNames({ loading: isLoading }, className), style: style },
        React.createElement(StyledStatusContainer, { role: "status" }, isLoading && 'Loading'),
        isLoading ? React.createElement(LoadingIndicator, null) : React.createElement(React.Fragment, null, children)));
}
//# sourceMappingURL=LoadingAwareContainer.js.map